import React, { useState } from "react";
import appConstants from "../../appConstants";
import ProviderIDManagerView from "./ProviderIDManagerView";
import ProviderTypes from "./ProviderType/ProviderTypes";

const ProviderIDManager = ({ providers, onProviderChange }) => {
  const [providerType, setProviderType] = useState("");
  const [providerID, setProviderID] = useState("");
  const [error, setError] = useState("");

  const addProvider = () => {
    if (providers.length >= 5) {
      setError("You cannot add more than 5 providers.");
      return;
    }
    if (!providerID.trim()) {
      setError("Provider ID cannot be empty.");
      return;
    }
    if (!providerType) {
      setError("Please select a provider type.");
      return;
    }
    onProviderChange([...providers, { type: providerType, id: providerID }]);
    setProviderID("");
    setProviderType("");
    setError("");
  };

  const removeProvider = (index) => {
    onProviderChange(providers.filter((_, i) => i !== index));
    setError("");
  };

  const handleAddProvider = (e) => {
    e.preventDefault();
    addProvider();
  }

  return (
    <>
      {/* Two-column layout */}
      <div className="row g-3 mt-3">
        {/* First Column - Provider ID Type Dropdown */}
        <div className="col-md-6">
          <label className="form-label form-label-warning">Provider ID Type</label>
          <ProviderTypes
            providerType={providerType}
            setProviderType={setProviderType}
          />
          {/* <select
            value={providerType}
            onChange={(e) => setProviderType(e.target.value)}
            className="form-select form-control"
          >
            <option value="">Select Provider Type</option>
            {appConstants.providerTypes.map((type) => (
              <option key={type} value={type}>
                {type}
              </option>
            ))}
          </select> */}
        </div>

        {/* Second Column - Input with Plus Icon */}
        <div className="col-md-6 position-relative">
          <label className="form-label form-label-warning">Provider ID</label>
          <form onSubmit={handleAddProvider}>
          <input
            type="text"
            placeholder="Enter Provider ID"
            value={providerID}
            onChange={(e) => setProviderID(e.target.value.replace(/[^a-zA-Z0-9]/g, ''))}
            className="form-control"
          />
          </form>
          {/* Plus Icon (Inside Input - Right) */}
          <div
            onClick={addProvider}
            className="position-absolute"
            style={{
              top: "50%",
              right: "20px",
              // transform: "translateY(-50%)",
              padding: "5px",
              cursor: 'pointer'
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="black"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M12 5v14M5 12h14" />
            </svg>
          </div>
        </div>
      </div>

      {/* Error Message */}
      {error && <p className="text-danger mt-2">{error}</p>}

      {/* Provider List */}
      <ProviderIDManagerView providers={providers} removeProvider={removeProvider}/>
    </>
  );
};

export default ProviderIDManager;
